import React from 'react'
import NoAccessToModuleDialog from 'app/NoAccessToModuleDialog'

interface Props {
  isFleetLeaseWhiteLabelEnabled: boolean
  isLeaseCompanySetUp: boolean
}

export const CheckIfLeaseCompanyIsSetUp = ({
  children,
  isFleetLeaseWhiteLabelEnabled,
  isLeaseCompanySetUp
}: React.PropsWithChildren<Props>) => {
  if (isFleetLeaseWhiteLabelEnabled && !isLeaseCompanySetUp) {
    return <NoAccessToModuleDialog />
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}
